module.exports = __webpack_public_path__ + "static/media/icon-close.9a59df9d.svg";